import {z} from '@hono/zod-openapi';

/** `car_detail`: the single ad, wrapped in `result`. */
export const priceReportCarDetailResponseSchema = z
  .object({result: z.unknown()})
  .openapi('PriceReportCarDetailResponse');
